module.exports = __webpack_public_path__ + "img/spotify.e264197c.svg";